(() => {
  const shopifyEventName = 'lovely_cards:whatsapp_enquiry_clicked';
  const dataLayerEventName = 'lovely_whatsapp_enquiry_clicked';

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-lovely-enquiry-button]');
      if (!button) return;

      const eventData = {
        product_id: button.dataset.productId || '',
        product_title: button.dataset.productTitle || '',
        variant_id: button.dataset.variantId || '',
        sku: button.dataset.productSku || '',
        product_url: button.dataset.productUrl || window.location.href,
        button_context: button.dataset.buttonContext || 'unknown',
      };

      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(shopifyEventName, eventData);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: dataLayerEventName, ...eventData });

      document.dispatchEvent(
        new CustomEvent('lovely:whatsapp-enquiry-clicked', { detail: eventData })
      );
    },
    { capture: true }
  );
})();
